import { render } from "./lyricsComponent.vue?vue&type=template&id=106f96c2&scoped=true"
import script from "./lyricsComponent.vue?vue&type=script&lang=js"
export * from "./lyricsComponent.vue?vue&type=script&lang=js"

import "./lyricsComponent.vue?vue&type=style&index=0&id=106f96c2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-106f96c2"]])

export default __exports__